import { render, staticRenderFns } from "./performance_record_list.vue?vue&type=template&id=6ec40e48&scoped=true"
import script from "./performance_record_list.vue?vue&type=script&lang=js"
export * from "./performance_record_list.vue?vue&type=script&lang=js"
import style0 from "./performance_record_list.vue?vue&type=style&index=0&id=6ec40e48&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec40e48",
  null
  
)

export default component.exports